var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"letter-container pl-3"},_vm._l((_vm.alphabet),function(letter){return _c('span',{key:letter,staticClass:"letter pr-3",class:{ active: _vm.isLetterActive(letter) },style:({ color: _vm.getLetterColor(letter) }),on:{"click":function () {
        _vm.goToLetter(letter);
      }}},[_vm._v(_vm._s(letter)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }